export default __webpack_public_path__ + "static/media/cloudUpload.d1276a5d.svg";